import { useEffect, useMemo, useState } from "react";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import SendIcon from "@mui/icons-material/Send";
import emailjs from "emailjs-com";
import { LabelInput } from "../components/Inputs";
import TeamForm from "../components/TeamForm";
import Button from '@mui/material/Button';
import { format } from "date-fns";
import OReg from "../../src/assets/pdf/parental-auth26.pdf";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@mui/material";
import { ExpandMore, PersonAdd, Warning } from "@mui/icons-material";
import { CustomButton } from "../components/generic/CustomButton";
import { styleConst } from "../utils/style";
import { CenteredPicture } from "../components/generic/CenteredPicture";
import { ButtonL } from "../components/generic/Buttons";
import KidForm from "../components/KidForm";

const Registration = () => {
  function ContactForm() {
    const [formData, setFormData] = useState({
      name: "",
      captain: "",
      telephone: "",
      email: "",
      players: [
        {
          surname: "",
          firstname: "",
          birthName: "",
          birthDate: "",
          sex: "",
          licensed: "",
          adress: "",
        },
        {
          surname: "",
          firstname: "",
          birthName: "",
          birthDate: "",
          sex: "",
          licensed: "",
          adress: "",
        },
        {
          surname: "",
          firstname: "",
          birthName: "",
          birthDate: "",
          sex: "",
          licensed: "",
          adress: "",
        },
      ],
    });

    const [kidFormData, setKidFormData] = useState({
      surname: "",
      firstname: "",
      birthDate: "",
      telephone: "",
      adress: "",
      email: "",
    });

    //Date
    const tournamentDate = useMemo(() => {
      return new Date(2026, 5, 7)
    }, []);

    const minDate = useMemo(() => {
      const newMinDate = new Date(tournamentDate)
      newMinDate.setFullYear(tournamentDate.getFullYear() - 13)
      newMinDate.setMonth(0)
      newMinDate.setDate(1)
      return newMinDate
    }, [tournamentDate])

    const maxDate = useMemo(() => {
      const newMaxDate = new Date(tournamentDate)
      newMaxDate.setFullYear(tournamentDate.getFullYear() - 14)
      newMaxDate.setMonth(11)
      newMaxDate.setDate(31)
      return newMaxDate
    }, [tournamentDate])

    const maxKidDate = useMemo(() => {
      const newMaxKidDate = new Date(tournamentDate)
      newMaxKidDate.setFullYear(tournamentDate.getFullYear() - 7)
      newMaxKidDate.setMonth(11)
      newMaxKidDate.setDate(31)
      return newMaxKidDate
    }, [tournamentDate])

    const registrationOpenDate = useMemo(() => {
      const dateTemp = new Date(tournamentDate)
      dateTemp.setMonth(dateTemp.getMonth() - 1)
      return dateTemp
    }, [tournamentDate])

    const currentDate = new Date();

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [isSending, setIsSending] = useState(false)

    const serviceId = process.env.REACT_APP_SERVICE_ID;
    const templateId = process.env.REACT_APP_TEMPLATE_ID;
    const userId = process.env.REACT_APP_USER_ID;
    
    const handleSubmit = (e) => {
      e.preventDefault()

      setIsSending(true)
      
      if(selectedForm === "Formulaire enfant") {

        const formattedKidFormData = `
        <p><strong>Nouvelle inscription tournoi enfant</strong></p>
        <p><strong>Nom :</strong> ${kidFormData.surname}</p>
        <p><strong>Prénom :</strong> ${kidFormData.firstname}</p>
        <p><strong>Date de Naissance :</strong> ${format(kidFormData.birthDate, "dd/MM/yyyy")}</p>
        <p><strong>Adresse :</strong> ${kidFormData.adress}</p>
        <p><strong>Email :</strong> ${kidFormData.email}</p>
        <p><strong>Téléphone :</strong> ${kidFormData.telephone}</p>
      `;
      
        const params = { 
          name: kidFormData.firstname + ' ' + kidFormData.surname,
          telephone: kidFormData.telephone,
          email: kidFormData.email,
          formData: formattedKidFormData };

        emailjs
          .send(serviceId, templateId, params, userId)
          .then((response) => {
            console.log("SUCCESS!", response.status, response.text);
            setSuccessMessage(
              "Email envoyé avec succès ! Nous vous confirmerons l'inscription de votre enfant par mail dans les plus brefs délais."
            );
          })
          .catch((error) => {
            console.log("FAILED...", error);
            setErrorMessage(
              "Erreur lors de l'envoi de l'email. Veuillez réessayer."
            );
          })
          .finally(() => {
            setIsSending(false)
          });

      } else {
        const { name, captain, telephone, email, players } = formData

        const errors = []

        if (!name) {
          errors.push("Le nom de l'équipe est requis.")
        }

        if (!captain) {
          errors.push("Le nom du capitaine est requis.")
        }

        if (!telephone) {
          errors.push("Le numéro de téléphone est requis.")
        }

        if (!email) {
          errors.push("L'adresse e-mail de l'équipe est requise.")
        }

        if (!players || players.length < 3) {
          errors.push("L'équipe doit avoir au moins 3 joueurs.")
        }

        const licensedCount = players.filter((player) => player.licensed === "oui").length
        if (licensedCount > 2) {
          errors.push("Il ne peut pas y avoir plus de 2 joueurs licenciés dans l'équipe.")
        }

        const validPlayers = players.filter((player) => {
          if (!player.surname || !player.firstname || !player.birthDate) return false
        
          const age = tournamentDate.getFullYear() - player.birthDate.getFullYear()
          return age >= 14
        })

        if (validPlayers.length < 3) {
          errors.push("Au moins 3 joueurs doivent avoir un prénom, un nom et être âgés d'au moins 14 ans.")
        }

        if(validPlayers.length < players.length) {
          errors.push("Tous les joueurs renseignés doivent avoir un prénom, un nom et être âgés d’au moins 14 ans.")
        }

        if(validPlayers.length === 8) {
          const wCount = players.filter((player) => player.sex === "femme").length
          if(wCount < 1) {
            errors.push("Une équipe doit comporter au moins une femme.")
          }
        }

        if (errors.length > 0) {
          setErrorMessage(errors.join(" "))
          setIsSending(false)
          return
        }
        setErrorMessage("")

        const formattedPlayersRows = formData.players
        .map(
          (player, index) =>
            `<tr>
              <td>${index + 1}</td>
              <td>${player.surname}</td>
              <td>${player.firstname}</td>
              <td>${format(player.birthDate, "dd/MM/yyyy")}</td>
              <td>${player.birthName}</td>
              <td>${player.sex}</td>
              <td>${player.licensed}</td>
              <td>${player.adress}</td>
            </tr>`
        )
        .join("");

      const formattedFormData = `
        <p><strong>Nom de l'équipe :</strong> ${formData.name}</p>
        <p><strong>Capitaine :</strong> ${formData.captain}</p>
        <p><strong>Téléphone :</strong> ${formData.telephone}</p>
        <p><strong>Email :</strong> ${formData.email}</p>
        <p><strong>Liste des joueurs :</strong></p>
        <table border="1" cellspacing="0" cellpadding="5">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Date de naissance</th>
              <th>Nom de Naissance</th>
              <th>Sexe</th>
              <th>Licencié</th>
              <th>Adresse</th>
            </tr>
          </thead>
          <tbody>
            ${formattedPlayersRows}
          </tbody>
        </table>
      `;

      const params = { 
        name: formData.name,
        captain: formData.captain,
        telephone: formData.telephone,
        email: formData.email,
        formData: formattedFormData 
      }

      emailjs
        .send(serviceId, templateId, params, userId)
        .then((response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSuccessMessage(
            "Email envoyé avec succès ! Nous vous confirmerons l'inscription de votre équipe par mail dans les plus brefs délais."
          );
        })
        .catch((error) => {
          console.log("FAILED...", error);
          setErrorMessage("Erreur lors de l'envoi de l'email. Veuillez réessayer.");
        })
        .finally(() => {
          setIsSending(false)
        });

        return

      }
      
    };

    const handleChange = (e) => {
      const { name, value, dataset } = e.target;
      const index = dataset.index;

      if (index !== undefined) {
        const updatedPlayers = [...formData.players];
        updatedPlayers[index] = {
          ...updatedPlayers[index],
          [name]: value,
        };

        setFormData({
          ...formData,
          players: updatedPlayers,
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    };

    const handleKfChange = (e) => {
      const { name, value } = e.target;
      setKidFormData({
          ...kidFormData,
          [name]: value,
        });
    }

    const addPlayer = () => {
      setFormData((prevState) => ({
        ...prevState,
        players: [
          ...prevState.players,
          {
            surname: "",
            firstname: "",
            birthDate: "",
            birthName: "",
            sex: "",
            licensed: "",
            adress: "",
          },
        ],
      }));
    };

    const removePlayer = () => {
      setFormData((prevState) => ({
        ...prevState,
        players: prevState.players.slice(0, -1),
      }));
    };

    const onDlBtnClick = (file, name) => {
      const link = document.createElement("a")
      link.href = file
      link.target = "_blank"
      link.rel = "noreferrer"
      link.download = name
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    };

    useEffect(() => {
      if (successMessage) {
        setDialogMessage(successMessage);
      }
      if (errorMessage) {
        setDialogMessage(errorMessage);
      }
    }, [successMessage, errorMessage]);

    // Onglets
    const [selectedForm, setSelectedForm] = useState("Formulaire adulte")

    const onClickForm = (t) => {
      setSelectedForm(t)
    }

    return (
      <main>
        <h1>Inscription</h1>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        <Dialog
          sx={{ zIndex: 1000000 }}
          open={!!dialogMessage || !!isSending}
          onClose={() => setDialogMessage("")}
        >
          <DialogContent>
            {successMessage && (
              <Alert severity="success">{successMessage}</Alert>
            )}
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
            {
              isSending && !errorMessage && !successMessage && 
                <div style={{
                  width: 300,
                  height: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
                  <h4 style={{
                    alignSelf: 'center',
                    marginBottom: 10,
                  }} >Envoi en cours</h4>
                  <CircularProgress color="red" size={100}/>
                </div>
            }
          </DialogContent>
        </Dialog>
        {currentDate < registrationOpenDate ? (
          <div style={{ padding: "20px" }}>
            <p style={{textAlign: 'center', marginBottom: 40}} >
              Les inscriptions pour le tournoi seront ouverte à partir du{" "}
              {`${tournamentDate.getDate()}/${tournamentDate.getMonth()}/${tournamentDate.getFullYear()}`}
            </p>
            <CenteredPicture
              customHeight={500}
              src={"https://guillaumevincent.fr/assets/history/large/tournoi_2025/61.jpg"}
              alt={"remise du chèque à l'institut Paoli-Calmettes"}
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{
            width: "100%", 
            maxWidth: 550, 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: "0 auto"
          }}>
            <div
              style={{
                flex: "flex",
                paddingTop: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                width: "100%", 
              }}
            >
              <Accordion sx={{
                marginRight: "5px",
                marginLeft: "5px",
              }} >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    "& *": {
                      alignItems: "center",
                      gap: "1rem",
                      color: styleConst.primaryColor,
                    },
                  }}
                >
                  <Warning />
                  <p>Informations obligatoires pour chaque joueur</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      Date de naissance OBLIGATOIRE pour avoir une licence
                      évènementielle.
                    </li>
                    <li>
                      Code postal et lieu de résidence pour l’assurance le jour
                      du tournoi.
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{
                marginRight: "5px",
                marginLeft: "5px",
              }}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    "& *": {
                      alignItems: "center",
                      gap: "1rem",
                      color: styleConst.primaryColor,
                    },
                  }}
                >
                  <Warning />
                  <p>Règles pour les équipes du tournoi adulte</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>5 à 8 joueurs</li>
                    <li>1 fille minimum</li>
                    <li> Pas plus de 2 licenciés ({tournamentDate.getFullYear() - 1}-{tournamentDate.getFullYear()}) d’un club de handball.</li>
                    <li>Sont considérés comme licenciés : les joueurs avec une
                      licence compétition, loisir ou arbitre.</li>
                    <li>Sont considérés comme non licenciés : Handfit et Dirigeant.</li>
                    <li>8 € par personne</li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{
                marginRight: "5px",
                marginLeft: "5px",
              }}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    "& *": {
                      alignItems: "center",
                      gap: "1rem",
                      color: styleConst.primaryColor,
                    },
                  }}
                >
                  <Warning />
                  <p>Pour les mineurs</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      Les personnes nées à entre {tournamentDate.getFullYear() - 13} et {tournamentDate.getFullYear() - 7} participent au tournoi enfants.
                    </li>
                    <li>
                      Les personnes nées avant 2013 participent au tournoi adulte.
                    </li>
                    <li>
                      Autorisation parentale obligatoire pour tous les joueurs
                      mineurs.
                    </li>
                    <li>8 € par personne</li>
                    <li>Télécharger les documents pour l'inscription d'un mineur : {" "}
                    <a href={OReg} target= "_blank" rel = "noreferrer" > Autorisation parentale</a>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                margin: 15,
              }}
              >
                <ButtonL 
                  isSelected={selectedForm === "Formulaire adulte"}
                  onClick={onClickForm}
                  primaryColor={styleConst.pgbackground}
                  secondaryColor={styleConst.primaryColor}
                  text="Formulaire adulte"
                />
                <ButtonL 
                  isSelected={selectedForm === "Formulaire enfant"}
                  onClick={onClickForm}
                  primaryColor={styleConst.pgbackground}
                  secondaryColor={styleConst.primaryColor}
                  text="Formulaire enfant"
                />
              </div>
              </div>
              {
                selectedForm === "Formulaire adulte" ?
                <div>
              <h3>Formulaire pour équipe adulte</h3>
              <section style={{ width: '100%', padding: "0px 5px" , display: "flex", gap: "0.5rem", flexWrap: "wrap"}}>
                <LabelInput
                  label={"Équipe"}
                  name={"name"}
                  onChange={handleChange}
                  type={"text"}
                  placeholder={"Nom de l'équipe"}
                />
                <LabelInput
                  label={"Capitaine"}
                  name={"captain"}
                  onChange={handleChange}
                  placeholder={"Nom du capitaine"}
                  type={"text"}
                />
                <LabelInput
                  label={"Téléphone"}
                  name={"telephone"}
                  onChange={handleChange}
                  placeholder={"Téléphone"}
                  type={"tel"}
                />
                <LabelInput
                  label={"Email d'équipe"}
                  name={"email"}
                  onChange={handleChange}
                  placeholder={"Email"}
                  type={"email"}
                />
              </section>
            <TeamForm
              handleChange={handleChange}
              playersData={formData.players}
              maxDate={maxDate}
            />
            <div
              style={{
                padding: "20px",
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "center",
                gap: "1rem",
                marginBottom: 10,
              }}
            >
              {formData && formData.players.length < 8 && (
                <CustomButton
                  buttonText="Ajouter un joueur"
                  clickAction={() => addPlayer()}
                  startIcon={<PersonAdd />}
                  primaryColor={styleConst.pgbackground}
                  secondaryColor={styleConst.primaryColor}
                />
              )}
              {formData.players.length > 3 && (
                <CustomButton
                  buttonText="Supprimer un joueur"
                  clickAction={() => removePlayer()}
                  startIcon={<PersonRemoveIcon />}
                  primaryColor={styleConst.pgbackground}
                  secondaryColor={styleConst.primaryColor}
                />
              )}
            </div>
            </div>
            :
            <div style={{
              width: "100%",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }} >
              <h3>Formulaire enfant individuel</h3>
              <KidForm handleChange={handleKfChange} maxDate={maxKidDate} minDate={minDate}/>
            </div>
          }
            <div style={{ marginBottom: 12, width: '80%',}}>
              <input
                type="checkbox"
                name="consent"
                required
              />
              <span style={{ marginLeft: 2, fontSize: 10,}} >
                Je certifie avoir informé les participants concernés et j’accepte les conditions relatives au droit à l’image et à la protection des données personnelles. 
                Voir notre <a href="/mentions-legales#donnees-personnelles" style={{ color: '#2563eb' }} >politique de confidentialité</a>.
              </span>
            </div>
            <Button
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                gap: 1,
                margin: '0 auto',
                mb: 0.2
              }}
              type="submit"
              variant="contained"
              size="large"
              color="red"
              startIcon={<SendIcon />}
            >
                Envoyer
            </Button>
              {
                selectedForm === "Formulaire enfant" &&
                  <article
                    style={{
                      display: "flex",
                      flexFlow: "row wrap",
                      justifyContent: "center",
                      gap: "0.7rem",
                      marginTop: "1rem",
                    }}
                  >
                    <p style={{ width: "100%", textAlign: "center" }}>
                      L'enfant ne pourra pas participer au tournoi sans l'autorisation parentale.
                    </p>
                    <p style={{ width: "100%", textAlign: "center" }}>
                      Télécharger votre autorisation à remplir ici :
                    </p>
                    <CustomButton
                      buttonText="Autorisation parentale"
                      clickAction={() => onDlBtnClick(OReg, "autorisation-parentale")}
                      primaryColor={styleConst.pgbackground}
                      secondaryColor={styleConst.primaryColor}
                    />
                </article>
              }
          </form>
        )}
      </main>
    );
  }

  return <ContactForm />;
};

export default Registration;
